export default __webpack_public_path__ + "static/media/logo_gobierno_jalisco.f87cbd08.svg";